import { useState } from 'react';

import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material'

import GenerateInfoPopover from './GenerateInfoPopover';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';

function ConfirmGenerateDialog({ open, onClose, onSubmit, sumUser, start, end }) {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(true);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);

  const handleOpenPopover = (event) => {
    setPopoverAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setPopoverAnchorEl(null);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
      >
        <DialogTitle id="alert-dialog-title">
          {t('titel', { ns: 'workRecordsPage', defaultValue: 'Detailierte Nachweise?' })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {i18n.language === 'de' ?
              <p>
                Es werden Arbeitszeitnachweise für {sumUser} {sumUser > 1 ? 'Mitarbeitende' : 'Mitarbeiter'} vom {start} bis einschließlich dem {end} erzeugt.
              </p>  
              :
              <p>Work records are generated for {sumUser} {sumUser > 1 ? 'employees' : 'employee'} from {start} up to and including {end}.</p>
          }
          </DialogContentText>
          <Box sx={{ display: 'flex', mt: 3 }}>
            <FormControlLabel
              value="top"
              control={<Checkbox checked={checked} onChange={() => setChecked(!checked)} />}
              label={t('detailiert', { ns: 'workRecordsPage', defaultValue: 'Detailierte Nachweise generieren' })}
              labelPlacement="end"
            />
            <IconButton sx={{ height: 'fit-content' }} onClick={handleOpenPopover}>
              <InfoOutlined />
            </IconButton>
            <GenerateInfoPopover
              open={Boolean(popoverAnchorEl)}
              anchorEl={popoverAnchorEl}
              onClose={handleClosePopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button onClick={() => { onSubmit(checked); onClose(); }} variant='contained'>
            Herunterladen
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default ConfirmGenerateDialog
